export default "__VITE_ASSET__DpzzwLoS__"